import { MetaReducer } from '@ngrx/store';

import { AppContextState } from './app-context.state';
import { appContextFeature, initialState } from './app-context.feature';

import { localStorageSync } from '@iss/wo-common/ngrx';

export const metaReducers: MetaReducer<AppContextState>[] = [
  localStorageSync({
    initialState,
    keys: [
      'role',
      'country',
      'customer',
      'site',
      'serviceLocation',
      'supplier',
      'contextAccepted',
    ],
    serializationKey: appContextFeature.name,
  }),
];
